import {
    getMeteringRecord,
    listMeteringRecords,
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {MeteringRecord} from "../types.ts";
import {billingApiClient} from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";

export type ListMeteringRecords = {
    listMeteringRecords: { items: MeteringRecord[], nextToken: string }
}

export type GetMeteringRecord = {
    getMeteringRecord: MeteringRecord
}


const client = billingApiClient;

const normalizeFilter = (filter: { [key: string]: string }) =>
    Object.keys(filter).reduce((acc: { [key: string]: string }, key) => {
        if (filter[key] !== '' && filter[key] !== undefined) {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

// FNP-534: MeteringRecords are read-only and backed by a SINGLE list operation.
// MeteringRecordsFilterInput supports only { customerId, meterId, state }, so —
// unlike billable-events (FNP-533) — there is no GSI branching: fetchRecords
// forwards whatever subset of those keys is active as the filter. meterCode and
// date-range filtering are NOT yet supported by the backend (FNP-538); they are
// deliberately absent here rather than faked client-side, which would only narrow
// the already-loaded page of a token-paginated list and hide later matches.
export const fetchRecords = async (query: ListRecordsQuery) => {
    const {filter, limit, nextToken} = query;
    const normalized = filter ? normalizeFilter(filter as { [key: string]: string }) : {};

    const response = await client.graphql<GraphQLQuery<ListMeteringRecords>>({
        query: listMeteringRecords,
        variables: {
            ...(Object.keys(normalized).length ? {filter: normalized} : {}),
            ...(query.sort ? {sort: query.sort} : {}),
            limit,
            nextToken,
        },
    });
    return {
        items: response.data?.listMeteringRecords.items,
        nextToken: response.data?.listMeteringRecords.nextToken,
    };
};

// MeteringRecord has a two-part key (customerId PK + sortKey SK); the detail page
// supplies both. There is no single-id get.
export const fetch = async (customerId: string, sortKey: string) => {
    const response = await client.graphql<GraphQLQuery<GetMeteringRecord>>({
        query: getMeteringRecord,
        variables: {customerId, sortKey},
    });
    return response.data?.getMeteringRecord;
};
